import * as React from "react";
import Autocomplete from "react-autocomplete";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import { PageTemplate } from "../common/PageTemplate";
import AutocompleteInput from "../common/inputv2/AutocompleteInput";
import Select from "../common/inputv2/select";
import DataLoadingSpinner from "../common/DataLoadingSpinner";
import MemberSelector from "./MemberSelector";
import { CostSummary } from "./CostEstimator/CostSummary";
import * as d from "../../reducers/domainReducer";

const SearchByTypes = {
    group: "group",
    cpt: "cpt"
};

/**
 * Container component for the Cost Estimator page.
 */

class CostEstimator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            memberId: this.props.hpIdentity ? this.props.hpIdentity.memberUserClaims.memberHccId : this.props.swhp,
            searchBy: SearchByTypes.group,
            kItems: [],
            autocompleteItems: [],
            keywordLoading: false,
            keywordNoResults: false,
            keyword: '',
            procedureId: -1,
            procedureName: null,
            member: null,
            procedure: null,
            groupDescript: '',
            showResults: false,
            error: null
        };
    }

    componentDidMount = () => {
        this.props.getGroupedProcedures(this.state.memberId);
        this.props.getGroupedProceduresByCpt(this.state.memberId);
    }

    componentDidUpdate = (prevProps) => {
        if (!this.state.memberId && (prevProps.swhp != this.props.swhp || prevProps.hpIdentity != this.props.hpIdentity)) {
            let newMemberId = this.props.hpIdentity ? this.props.hpIdentity.memberUserClaims.memberHccId : this.props.swhp;

            if (newMemberId && newMemberId !== "") {
                this.setState({ memberId: newMemberId });
            }
        }
        if (prevProps.groupedProcedures !== this.props.groupedProcedures) {
            let itemsList = this.props.groupedProcedures.map(procedure => {
                return { id: procedure.procedure_id, label: procedure.procedure_name, category: 'Procedure type: ' + procedure.procedure_type }
            });

            let categoryItems = itemsList.map(item => item.category)
                .filter((value, index, self) => self.indexOf(value) === index);
            categoryItems = categoryItems.map(category => {
                return { id: -1, label: category, category: category }
            });

            let orderedItems = [];

            categoryItems.forEach(category => {
                orderedItems.push(category);
                orderedItems = orderedItems.concat(itemsList.filter((item) => item.category == category.label));
            });

            this.setState({ kItems: orderedItems });

            let autoCompleteItemsList = this.props.groupedProcedures.map((item) => { return { id: item.group_descript, label: item.group_descript } });
                this.setState({
                    autocompleteItems: autoCompleteItemsList
            });
        }
    }

    setProcedureId = (procedureId) => this.setState({ procedureId });
    setProcedureName = (keyword) => this.setState({ procedureName: keyword });
    setKeyword = (keyword) => this.setState({ keyword });

    onSearchByChange = (event) => {
        this.setState({ searchBy: event.target.value });

        if (event.target.value === SearchByTypes.cpt) {
            let autoCompleteItemsList = this.props.cptProcedures.map((item) => { return { id: item.group_descript, label: item.group_descript } });
            this.setState({
                autocompleteItems: autoCompleteItemsList,
                keyword: '',
                error: null
            });
        }
        else {
            let autoCompleteItemsList = this.props.groupedProcedures.map((item) => { return { id: item.group_descript, label: item.group_descript } });
            this.setState({
                autocompleteItems: autoCompleteItemsList,
                keyword: '',
                error: null
            });
        }
    }

    onProcedureSelected = (val) => {
        let procedure = this.props.groupedProcedures.find(proc => proc.procedure_id === val);
        
        this.setState({ procedure: procedure, error: null });
        this.setProcedureId(procedure.procedure_id);
    }
    onKeywordSelected = (val, item) => {
        if (this.state.searchBy == SearchByTypes.cpt) {
            let groupedProcedure = this.props.cptProcedures.find(proc => proc.group_descript === val);

            this.setState({
                keyword: item.label,
                groupDescript: groupedProcedure,
                error: null
            });

        }
        else {
            let groupedProcedure = this.props.groupedProcedures.find(proc => proc.group_descript === val);

            this.setState({
                keyword: item.label,
                groupDescript: groupedProcedure,
                error: null
            });
        }
    }
    loadProcedureTypeAhead(val) {
        this.setState({ autocompleteItems: [], keywordLoading: true, groupDescript: "", keyword: "" });
        if (this.state.searchBy == SearchByTypes.cpt) {
            let cptProcedures = this.props.cptProcedures.map((item) => { return { id: item.group_descript, label: item.group_descript } });
            let items = cptProcedures.filter(option =>
                option.label && option.label.toLowerCase().includes(val.toLowerCase())
            );
            let matcheditem = cptProcedures.find(option =>
                option.label && option.label.toLowerCase() === val.toLowerCase()
            );

            if (matcheditem)
                this.setState({ autocompleteItems: items, keywordLoading: false, keywordNoResults: !(items.length > 0), keyword: matcheditem.label });
            else
                this.setState({ autocompleteItems: items, keywordLoading: false, keywordNoResults: !(items.length > 0) });
        }
        else {
            let groupedProcedures = this.props.groupedProcedures.map((item) => { return { id: item.group_descript, label: item.group_descript } });
            let items = groupedProcedures.filter(option =>
                option.label && option.label.toLowerCase().includes(val.toLowerCase())
            );
            let matcheditem = groupedProcedures.find(option =>
                option.label && option.label.toLowerCase() === val.toLowerCase()
            );

            if (matcheditem)
                this.setState({ autocompleteItems: items, keywordLoading: false, keywordNoResults: !(items.length > 0), keyword: matcheditem.label });
            else
                this.setState({ autocompleteItems: items, keywordLoading: false, keywordNoResults: !(items.length > 0) });
        }
    }

    setMember = (newMember) => {
        this.setState({ member: newMember });
        this.setState({memberId: newMember.MemberNbr})
    }
    submitForm = () => {
        //verify procedure
        if (!this.state.procedure && !this.state.groupDescript) this.setState({ error: 'Procedure must be selected.' })
        //error handling
        else {
            this.props.getCostEstimate(this.state.memberId,
                this.state.procedure?.procedure_id,
                this.state.groupDescript,
                this.state.procedure?.medicare_benefit_name,
                this.state.procedure?.other_benefit_name
            );
            this.setState({ showResults: true });
        } 
    }

    returnToForm = () => {
        this.props.clearProcedureCosts();
        this.setState({ showResults: false, keyword: '', keywordLoading: false, keywordNoResults: false, groupDescript: ''});

    }

    renderedOptions = () => {
        let renderedOptions = this.state.kItems.map((option, index) => {
            if (option.label == option.category) {
                return <option key={'option-'+  (option.id * index) } disabled className='category-option' value={option.id*index}>{option.label}</option>
            }
            if (option.id == this.state.procedureId) {
                return <option key={'option-' + option.id} value={option.id} selected>{option.label}</option>
            }
            return <option key={'option-' + option.id} value={option.id}>{option.label}</option>
        })


        return renderedOptions;
    }
    renderCostEstimatorForm = () => {
        return <div className='procedure-form row'>
            <div className='col-4'>
                <div onChange={this.onSearchByChange}>
                    <input type="radio" value={SearchByTypes.group} name="searchBy" defaultChecked={this.state.searchBy === SearchByTypes.group} /> Search by Group
                    <input type="radio" value={SearchByTypes.cpt} name="searchBy" defaultChecked={this.state.searchBy === SearchByTypes.cpt} /> Search by CPT Code
                </div>
                 <AutocompleteInput value={this.state.keyword} loading={this.state.keywordLoading}
                    placeholder="What Procedure are you looking for?" prependIcon="icon-search"
                    itemList={this.state.autocompleteItems} noResults={this.state.autocompleteItems.length > 0 ? false : true} autoHighlight={false}
                    onChange={(e, value) => { this.loadProcedureTypeAhead(value); this.setKeyword(value); }}
                    onSelect={this.onKeywordSelected}
                    required={true}
                />
                
            </div>
            <div className='col-1 for text-center'>
                <span>for</span>
            </div>
            <div className='col'>
                {!this.state.memberId && <DataLoadingSpinner />}
                {this.state.memberId && < MemberSelector onChange={this.setMember}/> }
            </div>
            <div className='col'>
                <button id='get-estimate' onClick={this.submitForm}> GET ESTIMATE</button>
                <div className='error'>{this.state.error}</div>
            </div>
        </div>;
    }
    displayResults = () => {
        if (!this.props.procedureCost) return <DataLoadingSpinner />;
        return <CostSummary procedureCost={this.props.procedureCost}
            memberDisplayName={this.state.member ? this.state.member.FirstName + ' ' + this.state.member.LastName : this.props.loggedInUser.DisplayName}
        />;

    }
    renderResults = () => {
        return <PageTemplate objectName='cost-estimator' pageTitle='Procedure Cost Estimator'>
            <div className='results-display'>
                <button id='return-to-form' onClick={() => { this.returnToForm() }}>&lt; START A NEW ESTIMATE</button>
                {this.displayResults()}
                <hr />
                <p>The information below contains important details about the cost estimate and information on the amount you may ultimately be required to pay for this item of service. </p>
                <ul>
                    <li>If you are treated by an out-of-network provider, after paying the cost-sharing amount determined by your health plan, you may still receive a bill for the difference between the amount the out-of-network provider charges for the item or service and the amount paid by your health plan. This is called balance billing, and this amount is <u>not</u> included in your cost estimate.</li>
                    <li>The actual charge for the item or service may be different from the cost estimate, depending on the actual care you receive.  For example, if your physician provides additional services during your visit, your charges could be more than the cost estimate.  This is one reason why it is important to discuss with your provider both before and during your visit which items and services you will receive and to request a new cost estimate if new information becomes available.</li>
                    <li>This cost estimate is not a benefit determination or guarantee of coverage for the item or service for which you requested information.  For example, your plan may need to determine whether the item or service is medically necessary in your case before making a payment.  You should follow your health plan’s process for filing a claim for benefits and contact your health plan to help determine if there are any additional requirements that apply to you as part of that process.</li>
                    <li>Copayment assistance and other third-party payments are not included in the statement of cost-sharing liability or an out-of-pocket maximum.</li>
                    <li>Preventive items may not be subject to cost-sharing liability (i.e., your share of costs for a covered item or service that you must pay, sometimes called “out of pocket costs”).</li>
                </ul>
                <p>Need more information?  Please call the phone number on the back of your Member Identification Card.</p>
                <br />
                <p>Prerequisites:</p>
                <ul>
                    <li>Prior Authorization: Your health plan must decide whether this item or service is medically necessary before it will cover this item or service. This is called prior authorization.  Your health plan may impose additional costs if you or your provider do not submit this item or service for prior authorization before the item or service is provided. Please click <a href="https://www.bswhealthplan.com/SiteCollectionDocuments/Medical-Policies/BSWHP-Prior-Authorization-List.pdf" target="_blank">here</a> to view Baylor Scott & White Health Plan’s Prior Authorization List for more information.</li>
                    <li>Concurrent Review: Your health plan may require a review during an ongoing course of treatment to determine whether the plan will continue to cover the item or service. This is called concurrent review. Your health plan may cease covering treatment if you or your provider do not submit this item or service for concurrent review within a specified time period after beginning treatment. </li>
                    <li>Step-therapy: Your health plan may not pay for higher-cost therapies without evidence that certain lower-cost therapies have not been effective for the participant, beneficiary, or enrollee (these are known as step-therapy protocols). You may be required to try a lower-cost alternative before your plan will cover this particular item or service. </li>
                </ul>

            </div>
        </PageTemplate>;
    }
    renderForm = () => {
        return <PageTemplate objectName='cost-estimator' pageTitle='Procedure Cost Estimator'>
            <div className='alt-background'>
                <div className='text-center'>Quickly find out how much a procedure may cost.</div>
                {this.renderCostEstimatorForm()}
                <div className='row text-center'>
                    <div className='col'>
                        <div className='bold-text sub-header-label'>Average Total Costs</div>
                        <div>See how much procedures may cost before seeing a doctor.</div>
                    </div>
                    <div className='col'>
                        <div className='bold-text sub-header-label'>Out-of-Pocket Expenses</div>
                        <div>Get an idea of what you may owe for any procedure.</div>
                    </div>
                    <div className='col'>
                        <div className='bold-text sub-header-label'>Estimates</div>
                        <div>Use print-friendly estimates to help budget for upcoming procedures.</div>
                    </div>
                </div>
            </div>
            <hr />
            <div className='content-block'>
                <div className='bold-text sub-header-label guesswork-title'>Take the guesswork out of costs</div>
                <div className='row'>
                    <div className='col'>Before you undergo any treatment (like chemotherapy) or procedure (such as a colonoscopy) in any of our in-network facilities, use our Procedure Cost Estimator. You'll receive a breakdown of all possible costs*, including physician fees, laboratory tests, and medications.</div>
                    <div className='col'>You'll also see what your progress will be towards meeting deductibles and out-of-pocket maximums. So now you can make informed choices about your healthcare, budget for upcoming procedures and treatments, and plan for future healthcare expenses.</div>
                </div>
            </div>
            <hr />
            <div className='bold-text content-block'>*The Procedure Cost Estimator provides an average and low to high range based on local market costs for select medical conditions, procedures, and services. These estimates cannot be relied on as the final, set costs for services, because the estimates may not reflect all of the changes related to a member's diagnosis, treatment, or procedure. Lastly, please be sure to verify if your plan covers the services or procedures selected prior to services being rendered.</div>
        </PageTemplate>
    }
    render = () => {
        if (this.state.showResults) {
            return this.renderResults();
        }
        else {
            return this.renderForm();
        }
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        error: state.healthPlanServices.error,
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        groupedProcedures: state.healthPlanServices.groupedProcedures,
        cptProcedures: state.healthPlanServices.cptProcedures,
        procedureCost: state.healthPlanServices.procedureCost,
        isFetching: state.healthPlanServices.isFetching,
        loggedInUser: d.hydrateProxyUser(state.domain.pu),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCostEstimate: (MemberNumber, ProcedureId, GroupDescript, MedicareBenefitName, OtherBenefitName) => dispatch({ type: types.HP_GET_PROCEDURE_COST_START, MemberNumber: MemberNumber, ProcedureId: ProcedureId, GroupDescript: GroupDescript, MedicareBenefitName: MedicareBenefitName, OtherBenefitName: OtherBenefitName}),
        getGroupedProcedures: (MemberNumber) => dispatch({ type: types.HP_GET_GROUPED_PROCEDURES_START, MemberNumber: MemberNumber }),
        getGroupedProceduresByCpt: (MemberNumber) => dispatch({ type: types.HP_GET_GROUPED_PROCEDURES_BY_CPT_START, MemberNumber: MemberNumber }),

        clearProcedureCosts: () => dispatch({ type: types.HP_GET_PROCEDURE_COST_CLEAR })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CostEstimator))
